import { render } from "./Carusel.vue?vue&type=template&id=57e745cc&scoped=true"
import script from "./Carusel.vue?vue&type=script&lang=js"
export * from "./Carusel.vue?vue&type=script&lang=js"

import "./Carusel.vue?vue&type=style&index=0&id=57e745cc&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e745cc"]])

export default __exports__